/**
 * Takes the navigators locale string and returns only the recognized 
 * supported language. In this case de / or en-US
 * @param navigatorLocale 
 * @returns 
 */
export const determineLocale = (navigatorLocale: string): string => {
    let locale = undefined
    if (navigatorLocale.includes("de")) {
        locale = 'de-DE'
    } else if (navigatorLocale.includes('en')) {
        locale = 'en-US'
    } else {
        locale = 'en-US'
    }
    return locale
}

export async function unwrapPromise(input: Promise<any>) {
    try {
      const data = await input
      return [data, null]
    } catch (error) {
      console.log(error)
      return [null, error]
    }
}

export function debugPrintPathUrlLike(segments: string[]): string {
    return segments.join("/")
}